// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BILZX","badges":"styles_badges__2jMQm"};